// src/layouts/FullImageBlock/FullImageBlock.js

import React from "react"
import styled from 'styled-components'
import { GatsbyImage } from "gatsby-plugin-image"

const FullImageBlock = ({ imageUpload }) => {

  return (
    <BlockContent>
      <div
      data-sal="slide-up"
      data-sal-duration="1000"
      data-sal-delay="300"
      data-sal-easing="ease"
      >
        <GatsbyImage image={imageUpload.localFile.childImageSharp.gatsbyImageData} alt={""} />
      </div>
    </BlockContent>
  )
}

const BlockContent = styled.section`
    max-width: 1360px;
    width: 100%;
    margin: 0 auto;
    margin-bottom: 20px;
    padding: 0 20px;
    @media(max-width:1000px) {
      max-width: 700px;
      flex-wrap: wrap;
    }
    @media(max-width:767px) {
      max-width: 500px;
      padding: 0;
      margin-top: 20px;
      margin-bottom: 20px;
    }
`

export default FullImageBlock